import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./Notificatio.module.css";
import Lottie from "lottie-react";
import Thumsup from "./Thumsup.json";
import companyStore from "../../../Store/Store";

const Notificatio = ({
  isVisible,
  onClose,
  isAdmin,
  TopUpNoti,
  className = "",
}) => {
  const navigate = useNavigate();
  console.log("isAdmin", isAdmin);
console.log("TopUpNoti",TopUpNoti);
console.log("isVisible",isVisible);
console.log("isAdmin",isAdmin);

  const onXCircleIconClick = useCallback(() => {
    navigate("/content/users");
  }, [navigate]);

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.containerNotifi}>
        <div
          className={
            !TopUpNoti ? styles.xCircleWrapper : styles.xCircleWrapper2
          }
        >
          {TopUpNoti && <div>Add Top-up</div>}
          <img
            className={styles.xCircleIcon}
            alt=""
            src="/xcircle1.svg"
            onClick={onClose}
          />
        </div>
        <div className={styles.httpslottiefilescomanimatParent}>
          <Lottie
            className={styles.httpslottiefilescomanimatIcon}
            animationData={Thumsup}
            loop={true}
          />
          {!TopUpNoti &&
            companyStore.userType == "AxisUser" &&
            (isAdmin ? (
              <div className={styles.userAddedSuccessfully}>
                
              </div>
            ) : (
              <div className={styles.userAddedSuccessfully}>
                New User Has Been Added
              </div>
            ))}
          {TopUpNoti && (
            <div className={styles.userAddedSuccessfully}>
              Top-up added successfully
            </div>
          )}
          {companyStore.userType == "PineLabUser" && !TopUpNoti && (
            <div className={styles.userAddedSuccessfully}>
              {isAdmin
                ? "Admin added successfully"
                : companyStore.initiateKYC == "AddedToUserList"
                ? "New User Has Been Added"
                : companyStore.initiateKYC == "AddedToPendingList"
                ? "KYC done! User addition is pending."
                : "KYC Link sent to the User Email & Phone."}
            </div>
          )}
        </div>
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
      </div>
    </div>
  );
};

Notificatio.propTypes = {
  className: PropTypes.string,
};

export default Notificatio;
